import { render, staticRenderFns } from "./MediaItemModal.vue?vue&type=template&id=0c3970b0&scoped=true"
import script from "./MediaItemModal.vue?vue&type=script&lang=ts"
export * from "./MediaItemModal.vue?vue&type=script&lang=ts"
import style0 from "./MediaItemModal.vue?vue&type=style&index=0&id=0c3970b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3970b0",
  null
  
)

export default component.exports